export default "__VITE_ASSET__b61c4cd7__"